<div class="row">
    <div class="col-md-6 offset-md-3">
        <div *ngIf="isLoading" style="text-align: center;">
            <app-loading-spinner></app-loading-spinner>
        </div>

        <!-- <div class="alert alert-danger" *ngIf="error">
            <p>{{ error }}</p>
        </div> -->

        <app-alert [message]="error"*ngIf="error" (close)=closeErrorBox()></app-alert>
        
        <form #authForm="ngForm" (ngSubmit)="onSubmit(authForm)" *ngIf="!isLoading">
            <div class="form-group">
                <label for="email">Email</label>
                <input 
                    type="email" 
                    name="email" 
                    id="email" 
                    class="form-control"
                    ngModel
                    required
                    email>
            </div>

            <div class="form-group">
                <label for="password">Password</label>
                <input 
                    type="password" 
                    name="password" 
                    id="password" 
                    class="form-control"
                    ngModel
                    required
                    minlength="6">
            </div>

                
            <div class="form-group">
                <button 
                    type="submit" 
                    class="btn btn-primary"
                    [disabled] = "authForm.invalid"
                    >{{ isLoginMode ? 'Login' : 'Signup' }}</button>
                <button type="button" class="btn btn-default" (click)="onSwitchMode()">Switch to {{ isLoginMode ? 'Signup' : 'Login' }}</button>
            </div>
                


            
        </form>
    </div>
</div>